export default __webpack_public_path__ + "static/media/animation_intro.3a556d95.gif";